module.exports = __webpack_public_path__ + "ms.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/ms.svg
// module id = 706
// module chunks = 0